"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const rates_1 = require("../../models/rates");
const rateTypes = Object.values(rates_1.RateTypeEnum);
exports.default = {
    rateId: joi_1.default.string().required(),
    rateType: joi_1.default.string()
        .valid(...rateTypes)
        .required(),
};
